import styled from 'styled-components';

export const View = styled.div`
  margin: 20px 0;
  min-height: 640px;
  padding-bottom: 70px;
  position: relative;
  width: 100%;

  @media (min-width: 800px) {
    max-width: 1500px;
    padding: 0 100px;
  }
  @media only screen and (max-width: 1500px) and (min-width: 800px) {
    zoom: 80%;
  }
`;

export const ResourcesContainer = styled.div`
  background: ${({ theme }) => theme.colors.neutral100};
  padding: 20px;
  border-radius: 10px;
  width: 100%;
`;

export const ResourcesHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderIcon = styled.div`
  width: 32px;
  height: 32px;
  background: ${(props) => props.theme.colors.primary900};
  box-sizing: border-box;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Resource = styled.a`
  color: #5a5a5a;
  font-size: 16px;
  line-height: 24px;
  margin-top: 20px;
  border: 1px solid ${(props) => props.theme.colors.neutral900};
  padding: 10px 20px;
  border-radius: 10px;
  cursor: pointer;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
`;

export const Title = styled.div`
  font-size: 22px;
  font-weight: 800;
  margin-left: 16px;
`;
